// Components
import ExpandableList from '@/components/common/ExpandableList.vue';

export default {
    components: { ExpandableList },

    props: {
        config: {
            type: Object,
            required: true
        },

        section: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            visible: false
        };
    },

    computed: {
        description() {
            return this.$utils.locales.getBestTranslation({
                translations: this.section.content,
                preferredLocale: this.$i18n.locale,
                workspaceLocales: this.config.event_details.languages,
            });
        },
        title() {
            return this.$utils.locales.getBestTranslation({
                translations: this.section.title,
                preferredLocale: this.$i18n.locale,
                workspaceLocales: this.config.event_details.languages,
            });
        }
    },

    created() {
        this.visible = Boolean(this.title || this.description);
    }
};
